(function () {
  "use strict";

  const VERSION = "0.4.0";

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // Market targeting (Shopify Markets): an item tagged "nz" or "nz, au" only
  // shows in those markets; "all"/untagged shows everywhere. QB.shop.market is
  // localization.country.iso_code from Liquid (headless sets it directly).
  // Unknown market fails open — better a generic answer than a hidden one.
  function marketMatches(item) {
    const tag = String(item?.market || "all").toLowerCase();
    if (tag === "all") return true;
    const market = String(window.QB?.shop?.market || "").toLowerCase();
    if (!market) return true;
    return tag.split(/[\s,]+/).indexOf(market) !== -1;
  }

  function getItems(config) {
    // Merchant-edited articles from the Worker (/config -> qb_faq metaobjects
    // or KV) win over everything; static config is the offline fallback.
    const server = window.QB?.serverFaq;
    if (Array.isArray(server) && server.length) {
      return { stub: false, items: server.filter(marketMatches) };
    }
    if (config.source === "gorgias-kb") {
      return { stub: true, items: [] };
    }
    const items = Array.isArray(config.items) ? config.items : [];
    return { stub: false, items: items.filter(marketMatches) };
  }

  function buildFaqHtml(items, stub) {
    if (stub) {
      return `
        <div class="qb-faq qb-faq--empty">
          <p class="qb-faq__message">Gorgias KB integration coming soon.</p>
          <p class="qb-faq__fine">Use <code>source: "static"</code> with an <code>items</code> array for now.</p>
        </div>
      `;
    }

    if (!items.length) {
      return `
        <div class="qb-faq qb-faq--empty">
          <p class="qb-faq__message">No help articles configured yet.</p>
        </div>
      `;
    }

    return `
      <div class="qb-faq">
        <div class="qb-faq__list">
          ${items
            .map(
              (item) => `
            <details class="qb-faq__item">
              <summary class="qb-faq__question">${escapeHtml(item.q)}</summary>
              <div class="qb-faq__answer">${escapeHtml(item.a)}</div>
            </details>
          `
            )
            .join("")}
        </div>
      </div>
    `;
  }

  class QBFaqSlot {
    constructor(panel) {
      this.panel = panel;
      this.config = window.QB?.slots?.faq || {};
      this.bind();
      this.render();
      // Server articles arrive with the shared /config fetch — re-render if
      // it lands after first paint (same pattern as drawer copy overrides).
      window.QB?.messagesReady?.then(() => this.render());
    }

    bind() {
      this.panel.addEventListener("toggle", (e) => {
        const details = e.target.closest("details");
        if (!details || !details.open) return;
        this.panel.querySelectorAll("details[open]").forEach((el) => {
          if (el !== details) el.open = false;
        });
      }, true);
    }

    render() {
      const { stub, items } = getItems(this.config);
      this.panel.innerHTML = buildFaqHtml(items, stub);
    }
  }

  window.QB = window.QB || {};
  window.QB.slotModules = window.QB.slotModules || {};
  window.QB.slotModules.faq = {
    version: VERSION,
    init(panel) {
      return new QBFaqSlot(panel);
    },
  };
})();
